import styled from 'styled-components';

export const Hero = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: 20px;
    max-width: 1100px;
    margin: 0 auto;
    padding: 50px 20px 30px;
    box-sizing: border-box;

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
        padding-top: 30px;
        text-align: center;
    }
`;

export const HeroText = styled.div`
    text-align: center;
`;

export const Title = styled.h1`
    font-size: 3.2em;
    margin: 0 0 8px;
    color: var(--text-title);

    @media (max-width: 700px) {
        font-size: 2.4em;
    }
`;

export const SubTitle = styled.h2`
    font-size: 1.4em;
    font-weight: 700;
    margin: 0 0 16px;
    color: var(--text-primary);
`;

export const Description = styled.p`
    font-size: 1.05em;
    line-height: 1.6;
    margin: 0 auto 24px;
    max-width: 480px;
`;

export const StoreBadge = styled.img`
    height: 50px;
`;

export const PhoneFrame = styled.div`
    justify-self: center;
    border: 10px solid var(--card);
    border-radius: 36px;
    box-shadow: var(--shadow);
    overflow: hidden;
    width: 240px;
    aspect-ratio: 9 / 19.5;
    background: linear-gradient(160deg, var(--lavender), var(--secondary));
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    @media (max-width: 700px) {
        width: 200px;
        margin-top: 10px;
    }
`;

export const Section = styled.section`
    max-width: 1100px;
    margin: 0 auto;
    padding: 40px 20px;
`;

export const SectionTitle = styled.h2`
    text-align: center;
    font-size: 2em;
    color: var(--text-title);
    margin: 0 0 32px;
`;

export const Steps = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
    }
`;

export const StepCard = styled.div`
    background: var(--card);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow);
    padding: 24px 20px;
    text-align: center;
`;

export const StepNumber = styled.div`
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 0 auto 14px;
    border-radius: 50%;
    background: var(--accent);
    color: #fff;
    font-weight: 800;
`;

export const StepTitle = styled.h3`
    margin: 0 0 8px;
    color: var(--text-title);
`;

export const StepDescription = styled.p`
    margin: 0;
    line-height: 1.5;
    font-size: 0.95em;
`;

export const ScreenshotStrip = styled.div`
    display: flex;
    gap: 20px;
    overflow-x: auto;
    padding: 10px 4px 20px;
    scroll-snap-type: x mandatory;

    @media (min-width: 900px) {
        justify-content: center;
    }
`;

export const ScreenshotCard = styled.div`
    flex: 0 0 auto;
    scroll-snap-align: center;
    text-align: center;
    width: 200px;
`;

export const ScreenshotFrame = styled.div`
    border: 6px solid var(--card);
    border-radius: 24px;
    box-shadow: var(--shadow);
    overflow: hidden;
    aspect-ratio: 9 / 19.5;
    background: linear-gradient(160deg, var(--peach), var(--mint));

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
`;

export const ScreenshotCaption = styled.p`
    margin: 10px 0 0;
    font-size: 0.85em;
    opacity: 0.85;
`;

export const FeatureList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
    }
`;

export const FeatureItem = styled.li`
    background: var(--card);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow);
    padding: 18px 20px;
    display: flex;
    gap: 12px;
    align-items: flex-start;
    line-height: 1.5;
`;

export const FeatureIcon = styled.span`
    font-size: 1.4em;
    flex-shrink: 0;
`;

export const FeatureText = styled.span`
    strong {
        color: var(--text-title);
    }
`;
